import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import {
    MCQDeleteButtonContainer,
} from "@sc/McqEditor.styled";
import './MatchFollowingQuiz.css';
import { v4 as uuidv4 } from "uuid";
import { uploadFile } from "@s/api/file";

const MatchFollowingQuiz = forwardRef((props, ref) => {
    const [column1Type, setColumn1Type] = useState('text');
    const [column2Type, setColumn2Type] = useState('text');
    const [column1Name, setColumn1Name] = useState('');
    const [column2Name, setColumn2Name] = useState('');
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (props.existingData) {
            populateFromExisting(props.existingData)
        }
    }, [props.existingData])

    const populateFromExisting = (data) => {
        if (!data || !data.column1 || !data.column2) return;

        const column1Options = data.column1.options || [];
        const column2Options = data.column2.options || [];

        // Set column types
        const col1Type = column1Options.length > 0 ? column1Options[0].type : 'text';
        const col2Type = column2Options.length > 0 ? column2Options[0].type : 'text';

        const col1Name = data.column1.name || '';
        const col2Name = data.column2.name || '';

        console.log(col1Name, col2Name)
        // Merge options
        const maxLength = Math.max(column1Options.length, column2Options.length);
        const mergedOptions = [];

        for (let i = 0; i < maxLength; i++) {
            const col1 = column1Options[i] || {};
            const col2 = column2Options[i] || {};

            mergedOptions.push({
                id: Date.now() + i,
                col1Value: col1.value || '',
                col1Media: col1.media || null,
                col2Value: col2.value || '',
                col2Media: col2.media || null,
                mapping: col2.correct_match_id || ''
            });
        }

        setColumn1Type(col1Type)
        setColumn2Type(col2Type)
        setColumn1Name(col1Name)
        setColumn2Name(col2Name)
        setOptions(mergedOptions.length > 0 ? mergedOptions : [])
    };

    const addNewOption = () => {
        if (options.length < 6) {
            setOptions([
                ...options,
                {
                    id: uuidv4(),
                    col1Value: '',
                    col1Media: null,
                    col2Value: '',
                    col2Media: null,
                    mapping: ''
                }
            ]);
        }
    };

    const removeOption = (index) => {
        const newOptions = options.filter((_, i) => i !== index);
        setOptions(newOptions);
    };

    const updateOption = (index, field, value) => {
        const newOptions = [...options];
        newOptions[index][field] = value;
        setOptions(newOptions);
    };

    const handleFileUpload = (index, column, event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                updateOption(index, column === 1 ? 'col1Media' : 'col2Media', reader.result);
            };
            reader.readAsDataURL(file);
            uploadFile(file).then((res) => {
                updateOption(index, column === 1 ? 'col1Media' : 'col2Media', res.file);
            });
        }
    };

    useImperativeHandle(ref, () => ({
        getFormattedData: () => {
            const column1Options = options.map((opt, index) => {
                const baseOption = {
                    id: index + 1,
                    type: column1Type,
                };

                if (column1Type === 'text') {
                    baseOption.value = opt.col1Value;
                } else {
                    baseOption.media = opt.col1Media;
                }

                return baseOption;
            });

            const column2Options = options.map((opt, index) => {
                const baseOption = {
                    id: index + 1,
                    type: column2Type,
                    correct_match_id: parseInt(opt.mapping) || null
                };

                if (column2Type === 'text') {
                    baseOption.value = opt.col2Value;
                } else {
                    baseOption.media = opt.col2Media;
                }

                return baseOption;
            });

            return {
                column1: {
                    type: column1Type,
                    name: column1Name,
                    options: column1Options
                },
                column2: {
                    type: column2Type,
                    name: column2Name,
                    options: column2Options
                }
            };
        },

        validateData: () => {
            for (let i = 0; i < options.length; i++) {
                const opt = options[i];

                // Check column 1
                if (column1Type === 'text' && !opt.col1Value.trim()) {
                    return { valid: false, message: `Column 1 option ${i + 1} is empty!` };
                }
                if (column1Type !== 'text' && !opt.col1Media) {
                    return { valid: false, message: `Column 1 option ${i + 1} media is missing!` };
                }

                // Check column 2
                if (column2Type === 'text' && !opt.col2Value.trim()) {
                    return { valid: false, message: `Column 2 option ${i + 1} is empty!` };
                }
                if (column2Type !== 'text' && !opt.col2Media) {
                    return { valid: false, message: `Column 2 option ${i + 1} media is missing!` };
                }

                // Check mapping
                if (!opt.mapping) {
                    return { valid: false, message: `Mapping for option ${i + 1} is not selected!` };
                }
            }

            return { valid: true };
        }
    }));

    const renderColumn1Input = (option, index) => {
        if (column1Type === 'text') {
            return (
                <textarea
                    className="matching_quiz_textarea"
                    placeholder="Enter text for Column 1"
                    value={option.col1Value}
                    onChange={(e) => updateOption(index, 'col1Value', e.target.value)}
                    rows="2"
                />
            );
        } else if (column1Type === 'image') {
            return (
                <div className="matching_quiz_media_container">
                    {option.col1Media ? (
                        <div className="matching_quiz_media_preview">
                            <img src={option.col1Media} alt="Column 1" className="matching_quiz_image" />
                            <MCQDeleteButtonContainer
                                onClick={() => updateOption(index, 'col1Media', null)}
                                className="matching_quiz_delete_media"
                            >
                                <img
                                    src={require("static/img/trash.png")}
                                    className="image-fluid"
                                    alt="Trash Icon"
                                />
                            </MCQDeleteButtonContainer>
                        </div>
                    ) : (
                        <label className="matching_quiz_upload_label">
                            <span className="matching_quiz_upload_text">Upload Image</span>
                            <input
                                type="file"
                                className="matching_quiz_file_input"
                                accept="image/*"
                                onChange={(e) => handleFileUpload(index, 1, e)}
                            />
                        </label>
                    )}
                </div>
            );
        } else if (column1Type === 'audio') {
            return (
                <div className="matching_quiz_media_container">
                    {option.col1Media ? (
                        <div className="matching_quiz_audio_container">
                            <audio controls className="matching_quiz_audio_player">
                                <source src={option.col1Media} />
                            </audio>
                            <MCQDeleteButtonContainer
                                onClick={() => updateOption(index, 'col1Media', null)}
                                className="matching_quiz_delete_audio"
                            >
                                <img
                                    src={require("static/img/trash.png")}
                                    className="image-fluid"
                                    alt="Trash Icon"
                                />
                            </MCQDeleteButtonContainer>
                        </div>
                    ) : (
                        <label className="matching_quiz_upload_label">
                            <span className="matching_quiz_upload_text">Upload Audio</span>
                            <input
                                type="file"
                                className="matching_quiz_file_input"
                                accept="audio/*"
                                onChange={(e) => handleFileUpload(index, 1, e)}
                            />
                        </label>
                    )}
                </div>
            );
        }
    };

    const renderColumn2Input = (option, index) => {
        if (column2Type === 'text') {
            return (
                <textarea
                    className="matching_quiz_textarea"
                    placeholder="Enter text for Column 2"
                    value={option.col2Value}
                    onChange={(e) => updateOption(index, 'col2Value', e.target.value)}
                    rows="2"
                />
            );
        } else if (column2Type === 'image') {
            return (
                <div className="matching_quiz_media_container">
                    {option.col2Media ? (
                        <div className="matching_quiz_media_preview">
                            <img src={option.col2Media} alt="Column 2" className="matching_quiz_image" />
                            <MCQDeleteButtonContainer
                                onClick={() => updateOption(index, 'col2Media', null)}
                                className="matching_quiz_delete_media"
                            >
                                <img
                                    src={require("static/img/trash.png")}
                                    className="image-fluid"
                                    alt="Trash Icon"
                                />
                            </MCQDeleteButtonContainer>
                        </div>
                    ) : (
                        <label className="matching_quiz_upload_label">
                            <span className="matching_quiz_upload_text">Upload Image</span>
                            <input
                                type="file"
                                className="matching_quiz_file_input"
                                accept="image/*"
                                onChange={(e) => handleFileUpload(index, 2, e)}
                            />
                        </label>
                    )}
                </div>
            );
        } else if (column2Type === 'audio') {
            return (
                <div className="matching_quiz_media_container">
                    {option.col2Media ? (
                        <div className="matching_quiz_audio_container">
                            <audio controls className="matching_quiz_audio_player">
                                <source src={option.col2Media} />
                            </audio>
                            <MCQDeleteButtonContainer
                                onClick={() => updateOption(index, 'col2Media', null)}
                                className="matching_quiz_delete_audio"
                            >
                                <img
                                    src={require("static/img/trash.png")}
                                    className="image-fluid"
                                    alt="Trash Icon"
                                />
                            </MCQDeleteButtonContainer>
                        </div>
                    ) : (
                        <label className="matching_quiz_upload_label">
                            <span className="matching_quiz_upload_text">Upload Audio</span>
                            <input
                                type="file"
                                className="matching_quiz_file_input"
                                accept="audio/*"
                                onChange={(e) => handleFileUpload(index, 2, e)}
                            />
                        </label>
                    )}
                </div>
            );
        }
    };

    return (
        <div className="matching_quiz_container">
            {/* Column Type Selectors */}
            <div className="matching_quiz_type_selectors">
                <div className="matching_quiz_type_selector_item">
                    <label className="matching_quiz_label">
                        Column 1 Name
                    </label>
                    <input value={column1Name} type='text' placeholder='column 1 name'
                        onChange={(e) => setColumn1Name(e.target.value)}
                    />
                </div>
                <div className="matching_quiz_type_selector_item">
                    <label className="matching_quiz_label">
                        Column 2 Name
                    </label>
                    <input value={column2Name} type='text'
                        placeholder ='column 2 name'
                        onChange={(e) => setColumn2Name(e.target.value)}
                    />
                </div>
            </div>

            <div className="matching_quiz_type_selectors">
                <div className="matching_quiz_type_selector_item">
                    <label className="matching_quiz_label">
                        Column 1 Type
                    </label>
                    <select
                        value={column1Type}
                        onChange={(e) => setColumn1Type(e.target.value)}
                        className="matching_quiz_select"
                    >
                        <option value="text">Text</option>
                        <option value="image">Image</option>
                        <option value="audio">Audio</option>
                    </select>
                </div>
                <div className="matching_quiz_type_selector_item">
                    <label className="matching_quiz_label">
                        Column 2 Type
                    </label>
                    <select
                        value={column2Type}
                        onChange={(e) => setColumn2Type(e.target.value)}
                        className="matching_quiz_select"
                    >
                        <option value="text">Text</option>
                        <option value="image">Image</option>
                        <option value="audio">Audio</option>
                    </select>
                </div>
            </div>

            {/* Options Grid Header */}
            <div className="matching_quiz_grid_header">
                <div className="matching_quiz_header_col1">Column 1</div>
                <div className="matching_quiz_header_col2">Column 2</div>
                <div className="matching_quiz_header_mapping">Mapping</div>
            </div>

            {/* Options List */}
            <div className="matching_quiz_options_list">
                {options.map((option, index) => (
                    <div key={option.id} className="matching_quiz_option_row">
                        {/* Column 1 */}
                        <div className="matching_quiz_column1">
                            {renderColumn1Input(option, index)}
                        </div>

                        {/* Column 2 */}
                        <div className="matching_quiz_column2">
                            {renderColumn2Input(option, index)}
                        </div>

                        {/* Mapping & Delete */}
                        <div className="matching_quiz_mapping_section">
                            <select
                                value={option.mapping}
                                onChange={(e) => updateOption(index, 'mapping', e.target.value)}
                                className="matching_quiz_mapping_select"
                            >
                                <option value="">Map to...</option>
                                {options.map((_, i) => (
                                    <option key={i} value={i + 1}>
                                        {i + 1}
                                    </option>
                                ))}
                            </select>
                            <button
                                onClick={() => removeOption(index)}
                                className="matching_quiz_delete_button"
                            >
                                <MCQDeleteButtonContainer
                                    className="matching_quiz_delete_audio"
                                >
                                    <img
                                        src={require("static/img/trash.png")}
                                        className="image-fluid"
                                        alt="Trash Icon"
                                    />
                                </MCQDeleteButtonContainer>
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Add Answer Button */}
            {options.length < 6 && (
                <button
                    onClick={addNewOption}
                    className="matching_quiz_add_button"
                >
                    + Add Answer
                </button>
            )}
        </div>
    );
});

export default MatchFollowingQuiz;